import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_57: FaireProductEntity = {
  token: "legacy_prod_abbott-57",
  type: "product",
  name: "Set of 4 Wood Handle Cheese Knives",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/99df0a409f1ce9104251a3797b083dd316d576f2c814a4ecc3dea615b343d303.jpeg",
  priceDollars: 32,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
